import {Pipe, PipeTransform} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';

@Pipe({name: 'WeekDateFormat'})
export class WeekDateFormatPipe implements PipeTransform {

    constructor(private translator: TranslateService) {
    }

  /**
   * @param value
   * @see NgbDateCustomParserFormatter
   */
    transform(value: string) {
      if (!value) {
        return '';
      }
      const mdt = moment(value);

      if (!mdt.isValid()) {
        return '';
      }
      const firstDayOfWeek = mdt.startOf('isoWeek');
      return this.translator.instant('global.week') + firstDayOfWeek.format(' W, YYYY');
    }
}
